import Logging from '@fjell/logging';

const LibLogger = Logging.getLogger('@fjell/lib');

export default LibLogger;
